export const FETCH_EMPLOYEE_RESIGNATION = "FETCH_EMPLOYEE_RESIGNATION";
export const FETCH_EMPLOYEE_RESIGNATION_SUCCESS = "FETCH_EMPLOYEE_RESIGNATION_SUCCESS";

export const SAVE_EMPLOYEE_RESIGNATION = "SAVE_EMPLOYEE_RESIGNATION";
export const SAVE_EMPLOYEE_RESIGNATION_SUCCESS = "SAVE_EMPLOYEE_RESIGNATION_SUCCESS";

export const SAVE_EMPLOYEE_REJOIN = "SAVE_EMPLOYEE_REJOIN";
export const SAVE_EMPLOYEE_REJOIN_SUCCESS = "SAVE_EMPLOYEE_REJOIN_SUCCESS";

export const EMPLOYEE_RESIGNATION_FAILURE = "EMPLOYEE_RESIGNATION_FAILURE";
